import { useEffect } from 'react';

import { whatsNewData } from '@/features/userManual/components/WhatsNew/whatsNewData';
import { useAccountStore } from '@/stores/accountStore';
import { useWhatsNewStore } from '@/stores/whatsNewStore';

const WhatsNewInitializer = () => {
    const { initializeWhatsNewStatus, setFilteredWhatsNewData } = useWhatsNewStore();
    const { userProfile } = useAccountStore();

    // TODO: Filter data based on feature toggles is not working well. Fix this
    // const filteredData = whatsNewData.filter(item => {
    //   const { value: isItemEnabled } = item.toggle ? useFeatureToggle(item.toggle) : { value: true };
    //   return isItemEnabled;
    // });

    useEffect(() => {
        setFilteredWhatsNewData(whatsNewData);
        initializeWhatsNewStatus(userProfile?.email, whatsNewData);
    }, [userProfile?.email]);

    return null;
};

export default WhatsNewInitializer;
